module.exports = __webpack_public_path__ + "img/metro.2da621a1.jpg";